import environment from '../../../common/environment';
import { getResponseData } from '../../../common/utils/api-utils';
import { getAuthenticationHeaders, getDefaultHeaders } from '../../../common/utils/auth-utils';
import { mapMagentoResponseToReturnResponse } from '../mappings/return.mapping';
import {
  ReturnAttachmentUrlRequestParams,
  ReturnRequestParams,
  ReturnResponse
} from '../interfaces/return-request.interface';

const BASE_API = `${environment().magentoUrl}/rest/${environment().checkoutFlow}/V1/returns`;

const APIS = {
  openReturn: `${BASE_API}/mine/`,
  getPresignedUrl: `${BASE_API}/mine/case-attachment-url/`
}

export async function openReturn(params: ReturnRequestParams): Promise<ReturnResponse> {
  return mapMagentoResponseToReturnResponse(await _doPostRequest(APIS.openReturn + params.orderId, params.returnRequest));
}

export async function getPresignedUrl(params: ReturnAttachmentUrlRequestParams): Promise<string> {
  return _doPostRequest(APIS.getPresignedUrl + params.orderNumber, params.returnAttachmentUrlRequest);
}

async function _doPostRequest(url: string, requestBody: any, authenticated: boolean = true) {
  return getResponseData(
    new Request(new URL(url), {
      method: 'POST',
      credentials: 'include',
      headers: authenticated ? getAuthenticationHeaders() : getDefaultHeaders(),
      body: JSON.stringify(requestBody)
    })
  );
}